import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddHelpline from "./AddHelpline";
import EditHelpline from "./EditHelpline";
import ViewHelpline from "./ViewHelpline";

import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");
class Helpline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModel: false,
      showEditModel: false,
      HelplineViewShow: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.fetchHelplines();
  }

  handleAddHelpline = () => {
    this.setState({
      showAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showAddModel: false,
    });
  };

  handleEditHelpline = (item) => {
    this.setState({
      showEditModel: true,
      ItemList: item,
    });
  };

  closeEditModel = () => {
    this.setState({ showEditModel: false });
  };

  handleHelplineView = (item) => {
    this.setState({
      HelplineViewShow: true,
      helplineViewDtls: item,
    });
  };

  handleClosehelpline = () => {
    this.setState({ HelplineViewShow: false });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.helplineSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  render() {
    let p = this.state.page + 1;
    const count = this.props.HelplineCount && this.props.HelplineCount;
    let helplinePageCount = Math.ceil(count / this.state.perPage);
    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Helpline</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddHelpline()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddHelpline
                showAddModel={this.state.showAddModel}
                closeAddModel={this.closeAddModel}
                AddHelpline={this.props.AddHelpline}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th style={{ width: "7%" }}>SL NO</th>
                    <th style={{ width: "20%" }}>Support Number</th>
                    <th style={{ width: "20%" }}>Support Email</th>
                    <th>Role</th>
                    <th>Active</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.HelplineList &&
                    this.props.HelplineList.map((item, i) => (
                      <tr key={i}>
                        <td>{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.sprtNo}
                        </td>
                        <td>{item !== null && item.sprtEmail}</td>
                        <td className="cmn_Cap commonDesc">
                          {item !== null && item.role}
                        </td>
                        <td>{item !== null && item.isActive ? "Yes" : "No"}</td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleHelplineView({
                                  item: item,
                                })
                              }
                            ></i>
                            <ViewHelpline
                              show={this.state.HelplineViewShow}
                              handleClose={this.handleClosehelpline}
                              helplineViewDtls={this.state.helplineViewDtls}
                              resetPage={this.resetPage}
                            />

                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditHelpline(item)}
                            ></i>
                            <EditHelpline
                              showEditModel={this.state.showEditModel}
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditHelpline={this.props.EditHelpline}
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {(this.props.HelplineList === undefined ||
                (this.props.HelplineList &&
                  this.props.HelplineList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Helplines Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {helplinePageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={helplinePageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default Helpline;
